export const createMultiSelectLabel = <T>(
    defaultLabel: string,
    getItemLabel: (value: string) => T | undefined,
    extractLabel: (item: T) => string,
) => {
    return (value: string[] | undefined) => {
        if (!value?.length) {
            return defaultLabel;
        }

        if (value.length === 1) {
            const item = getItemLabel(value[0]);
            return `${defaultLabel}: ${item ? extractLabel(item) : value[0]}`;
        }

        return `${defaultLabel}: ${value.length}`;
    };
};

export const createSelectLabel = <T>(
    defaultLabel: string,
    getItemLabel?: (value: string) => T | undefined,
    extractLabel?: (item: T) => string,
) => {
    return (value: string | undefined) => {
        if (!value) {
            return defaultLabel;
        }

        // If helper functions are provided, use them to get the readable label
        if (getItemLabel && extractLabel) {
            const item = getItemLabel(value);
            return `${defaultLabel}: ${item ? extractLabel(item) : value}`;
        }

        // Otherwise, just use the raw value
        return `${defaultLabel}: ${value}`;
    };
};

interface IIncludeExcludeLabelConfig {
    defaultLabel: string;
    includedLabel: string;
    excludedLabel: string;
}

export const createIncludeExcludeLabel = (config: IIncludeExcludeLabelConfig) => {
    const formatPart = (label: string, items?: string[]) => {
        if (!items || !items.length) {
            return null;
        }
        return items.length === 1 ? `${label}: ${items[0]}` : `${label}: ${items.length}`;
    };

    return (value: { include?: string[]; exclude?: string[] } | undefined) => {
        if (!value) {
            return config.defaultLabel;
        }
        const parts = [
            formatPart(config.includedLabel, value.include),
            formatPart(config.excludedLabel, value.exclude),
        ].filter(Boolean);
        return parts.length ? parts.join(", ") : config.defaultLabel;
    };
};
